<template>
    <div class="inline-flex items-center justify-center overflow-hidden rounded-full circle--test">
        <svg class="w-20 h-20">
            <circle
                class="text-gray-300"
                stroke-width="5"
                stroke="text-blue-600"
                fill="transparent"
                r="30"
                cx="40"
                cy="40"
            />
            <circle
                class="text-blue-600 loader--circle"
                stroke-width="5"
                :stroke-dasharray="circumference"
                :stroke-dashoffset="circumference - (percentage > 100 ? 100 : percentage) / 100 * circumference"
                stroke-linecap="round"
                stroke=""
                fill="transparent"
                r="30"
                cx="40"
                cy="40"
            />
        </svg>
        <span class="absolute text-xl text--loader text-blue-700">{{ Math.round(percentage > 100 ? 100 : percentage) }} %</span>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                circumference: this.radius * 2 * Math.PI,
            }
        },
        props: {
            radius: Number,
            percentage: Number
        }
    }
</script>

<style scoped>
.loader--circle {
    transition: stroke-dashoffset 0.3s ease-out;
}

.text--loader {
    transition: all 0.3s ease-out;
}
</style>
